module.exports = __webpack_public_path__ + "img/bespoke123_13.83179c00.jpg";